import styled from 'styled-components';
import breakpoints from '../../styles/breakpoints';

const Spacer = styled.div`
  height: 58px;

  ${breakpoints.medium`
    height: 75px;
  `};

  ${breakpoints.large`
    height: 140px;
  `};
`;

export default Spacer;
